var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPilot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pilot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pilot_1_",
    fill: "##67b437",
    d: "M70.866,2.268C31.728,2.268,0,33.996,0,73.134C0,112.271,31.728,144,70.866,144 c39.138,0,70.866-31.729,70.866-70.866C141.732,33.996,110.004,2.268,70.866,2.268z M115.102,34.916 c-2.848,5.343-18.357,20.592-18.357,20.592l1.646,51.798l-7.278,9.023L77.237,71.907L56.404,91.678l1.034,18.118l-7.915,6.597 l-4.737-17.839c-0.239,0.257-1.029,1.013-3.328,3.083c-4.116,3.71-5.088,0.604-2.375-2.5c2.713-3.103,3.312-3.145,3.312-3.145 l-16.93-7.707l9.915-6.24l13.503,4.094l22.021-20.9L28.377,45.996l5.127-5.923l56.71,7.366c0,0,16.898-14.98,20.928-16.692 C115.176,29.031,117.947,29.569,115.102,34.916z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilot);
export default __webpack_public_path__ + "static/media/pilot.5ff8a0e7.svg";
export { ForwardRef as ReactComponent };